import script from "./WhatsappButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhatsappButton.vue?vue&type=script&setup=true&lang=ts"

import "./WhatsappButton.vue?vue&type=style&index=0&id=a7114a42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7114a42"]])

export default __exports__